import { render } from "./DisabledPage.vue?vue&type=template&id=30f8d381&scoped=true"
import script from "./DisabledPage.vue?vue&type=script&lang=js"
export * from "./DisabledPage.vue?vue&type=script&lang=js"

import "./DisabledPage.vue?vue&type=style&index=0&id=30f8d381&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f8d381"]])

export default __exports__